import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { IssueBase, IssueVisibilityType } from '../@types';
import { KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetIssuesRequest = KeyPaginationQueryParams & {
	visibilityType: IssueVisibilityType;
};

export type GetIssuesRequestWithoutVisibility = Omit<GetIssuesRequest, 'visibilityType'>;

export type GetIssuesResponse = PaginatedResource<IssueBase>;

export const getIssues = createGetEndpoint<GetIssuesRequest, GetIssuesResponse>(
	(request) => `/api/v3/core/sonar-objects/issues?${getQueryString(request)}`
);
